import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1478">
      <Hero data-id="element-1479" />
      <LocalTrust data-id="element-1480" />
      <Services data-id="element-1481" />
      <HowItWorks data-id="element-1482" />
      <FAQ data-id="element-1483" />
      <Reviews data-id="element-1484" />
    </main>;
}